import { render, staticRenderFns } from "./ComplaintStatus.vue?vue&type=template&id=4a00c31f"
import script from "./ComplaintStatus.vue?vue&type=script&lang=js"
export * from "./ComplaintStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports